import "./scss/newsletter-denim-zero.scss"

import { Form } from "../../../components/Form"
import type { WidgetAppProps, WidgetProps } from "../../../types/widget.props"

export function WidgetDenimZero({ configuracaoSite, textosPersonalizados }: Readonly<WidgetProps>) {
    return (
        <div className="news-denim-zero news-footer flex center">
            <div className="container">
                <h2>{textosPersonalizados.newsletterTitle}</h2>
                <h4>{textosPersonalizados.newsletterDescription}</h4>
                
                <Form
                    configuracaoSite={configuracaoSite}
                    textosPersonalizados={textosPersonalizados}
                    dinformname="newsletter-widget-denim-zero"
                    className={{
                        form: "flex",
                        nome: "nome",
                        email: "email",
                        telefone: "telefone",
                        button: "button button-medium button-primary"
                    }}
                />
            </div>
        </div>
    )
}

export default class WidgetDenimZeroApp {
    constructor(props: WidgetAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<WidgetDenimZero {...props} />)
    }
}
